import { CrudForm } from '../shared/CrudPage';
import { designationService } from '@kss/api';
import type { Designation, DesignationCreate, DesignationFilter } from '@kss/api';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  level: number;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  level: 0,
  isActive: true,
};

export default function NewDesignation() {
  return (
    <CrudForm<Designation, DesignationCreate, DesignationFilter, F>
      title="designation"
      service={designationService}
      idKey="designationId"
      basePath="/panel/designations"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'level', label: 'Level (numeric)', type: 'number' },
        { key: 'description', label: 'Description' },
        { key: 'isActive', label: 'Status', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        level: Number((r as unknown as Record<string, unknown>).level ?? 0),
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        designationId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        level: f.level ? Number(f.level) : undefined,
        isActive: f.isActive,
      } as Designation)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
